import ConfigManager from '@/config/ConfigManager.js' 
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators'; 
import { PolicyModel, PolicyDocDesc, PolicyRenews } from '../model/EDocumentModel.js';

export default { 
    apiDocumentLine: function (token) {   
        let url = ConfigManager.getApiModuleUrl() + "/tni/documentline?device_app_id=" + ConfigManager.getAppId();
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => { 
            let policyList = res.data?.policys ? res.data.policys : res.data; 
            let policyRenews = res.data?.PolicyRenews ? res.data.PolicyRenews : [];
             
            let policyListDataFullCustomer = [];
            let policyListDataFullCustomerNotConfirm = [];
            let policyListDataFullCustomerConfirmNull = [];
            let policyListDataEpacCard = [];
            let policyListDataTaxexp = [];
            let policyListRenew = [];

            for (let i = 0; i < policyList.length; i++) {
                let _policy = policyList[i]; 
                let policy = new PolicyModel();
                policy.setValue(_policy);

                for (let j = 0; j < _policy.PolicyDoc_desc.length; j++) {
                    let doc = _policy.PolicyDoc_desc[j];

                    let policyDoc = new PolicyDocDesc();
                    policyDoc.setValue(doc);

                    let data = {
                        doc: policyDoc,
                        policy: policy
                    };
                    if (doc.supDocType == "FullCustomer") {
                        if (policy.isConfirm) {
                            policyListDataFullCustomer.push(data);
                        } else if(policy.isConfirm == null || policy.isConfirm == undefined) {
                            policyListDataFullCustomerConfirmNull.push(data);
                        } else {
                            policyListDataFullCustomerNotConfirm.push(data);
                        }
                        
                    }
                    else if (doc.supDocType == "Taxexp") {
                        policyListDataTaxexp.push(data);
                    } else if (doc.supDocType == "EPACARD") {
                        policyListDataEpacCard.push(data);
                    }
                } 
            }

            for (let i = 0; i < policyRenews.length; i++) {
                let renew = policyRenews[i];

                let policy= new PolicyRenews();
                policy.setValue(renew);

                policyListRenew.push(policy);
            }

            let hasDocument = policyListDataFullCustomer.length > 0 ||
            policyListDataEpacCard.length > 0 ||
            policyListDataTaxexp.length > 0 ||
            policyListDataFullCustomerNotConfirm.length > 0 ||
            policyListDataFullCustomerConfirmNull.length > 0 ||
            policyListRenew.length > 0; 

            let dataDict =  {
                policyListDataFullCustomer: policyListDataFullCustomer,
                policyListDataEpacCard: policyListDataEpacCard,
                policyListDataTaxexp: policyListDataTaxexp,
                hasDocument: hasDocument,
                policyListDataFullCustomerNotConfirm: policyListDataFullCustomerNotConfirm,
                policyListDataFullCustomerConfirmNull: policyListDataFullCustomerConfirmNull,
                policyListRenew: policyListRenew
            };
                
            return dataDict;
        }));
    },
}
